import { render, staticRenderFns } from "./Paper.vue?vue&type=template&id=218c7ac8&scoped=true&"
import script from "./Paper.vue?vue&type=script&lang=js&"
export * from "./Paper.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/sheets-of-paper.css?vue&type=style&index=0&id=218c7ac8&scoped=true&lang=css&"
import style1 from "@/assets/css/sheets-of-paper-a4.css?vue&type=style&index=1&id=218c7ac8&scoped=true&lang=css&"
import style2 from "./Paper.vue?vue&type=style&index=2&id=218c7ac8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "218c7ac8",
  null
  
)

export default component.exports